// MessageMetaBlock.js
const MessageMetaBlocks = ({
  organizationId,
  thematics = [],
  triggers = [],
  guardrails = [],
  webs = [],
  filesMeta = [],
  frames = [],
  notificationsList = [],
  fileSearchQueries = [],
  connectioObjectsList = [],
  reasoningSteps = [],
}) => {
  const hasAnything =
    (thematics && thematics.length > 0) ||
    (triggers && triggers.length > 0) ||
    (guardrails && guardrails.length > 0) ||
    (webs && webs.length > 0) ||
    (filesMeta && filesMeta.length > 0) ||
    (frames && frames.length > 0) ||
    (notificationsList && notificationsList.length > 0) ||
    (fileSearchQueries && fileSearchQueries.length > 0) ||
    (connectioObjectsList && connectioObjectsList.length > 0) ||
    (reasoningSteps && reasoningSteps.length > 0);

  if (!hasAnything) return null;

  const linkStyle = {
    color: 'inherit',
    transition: 'none',
  };

  const listStyle = {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  };

  const sectionStyle = {
    marginBottom: '8px',
  };

  const separatorStyle = {
    border: 'none',
    borderTop: '1px solid #ccc',
    margin: '8px 0',
  };

  return (
    <div className="message-meta-blocks">
      <hr style={separatorStyle} />

      {thematics.length > 0 && (
        <div className="meta-section" style={sectionStyle}>
          <strong>Thematics:</strong>{' '}
          <ul style={listStyle}>
            {thematics.map((t, i) => (
              <li key={i}>
                <span>
                  {t.name} ({Math.round(t.probability * 100)}%)
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {guardrails.length > 0 && (
        <div className="meta-section" style={sectionStyle}>
          <strong>Guardrails:</strong>{' '}
          <ul style={listStyle}>
            {guardrails.map((g, i) => (
              <li key={i}>
                <span>{g.name}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {triggers.length > 0 && (
        <div className="meta-section" style={sectionStyle}>
          <strong>Triggers:</strong>{' '}
          <ul style={listStyle}>
            {triggers.map((t, i) => (
              <li key={i}>
                <span>{t.action}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {webs.length > 0 && (
        <div className="meta-section" style={sectionStyle}>
          <strong>Websearch:</strong>
          <ul style={listStyle}>
            {webs
              .filter((a) => a && a.url && a.title)
              .map((a, i) => (
                <li key={i}>
                  <a href={a.url} target="_blank" rel="noopener noreferrer" style={linkStyle}>
                    {a.title}
                  </a>
                </li>
              ))}
          </ul>
        </div>
      )}

      {filesMeta.length > 0 && (
        <div className="meta-section" style={sectionStyle}>
          <strong>Documents:</strong>
          <ul style={listStyle}>
            {filesMeta.map((file, i) => (
              <li key={i}>
                <a
                  href={`/organizations/${organizationId}/documents-hub/${file.file_key}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={linkStyle}
                >
                  {file.original_name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}

      {frames.length > 0 && (
        <div className="meta-section" style={sectionStyle}>
          <strong>Frames:</strong>
          <ul style={listStyle}>
            {frames.map((frame, i) => (
              <li key={i}>
                <a
                  href={`/organizations/${organizationId}/agent-frames/${frame.frame_key}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={linkStyle}
                >
                  {frame.frame_name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}

      {notificationsList.length > 0 && (
        <div className="meta-section" style={sectionStyle}>
          <strong>Notifications:</strong>
          <ul style={listStyle}>
            {notificationsList.map((notification, i) => (
              <li key={i}>
                <a
                  href={`/organizations/${organizationId}/notifications-hub/${notification.notification_key}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={linkStyle}
                >
                  {notification.notification_name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}

      {connectioObjectsList.length > 0 && (
        <div className="meta-section" style={sectionStyle}>
          <strong>Connection objects:</strong>
          <ul style={listStyle}>
            {connectioObjectsList.map((connection_object, i) => (
              <li key={i}>
                <a
                  href={`/organizations/${organizationId}/connection-objects/${connection_object.connection_object_key}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={linkStyle}
                >
                  {connection_object.connection_object_name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}

      {fileSearchQueries.length > 0 && (
        <div className="meta-section" style={sectionStyle}>
          <strong>File search queries:</strong>
          <ul style={listStyle}>
            {fileSearchQueries.map((q, i) => (
              <li key={i}>
                <span>{q}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {reasoningSteps?.length > 0 && (
        <div className="meta-section" style={sectionStyle}>
          <strong style={{ display: 'block', marginBottom: '8px' }}>Reasoning steps:</strong>

          {reasoningSteps.map((step, index) => (
            <div className="metrics" key={`reasoning-step-${index}`}>
              <em>{step}</em>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MessageMetaBlocks;
